var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5C5.5875 1.5 5.23438 1.64687 4.94063 1.94062C4.64688 2.23437 4.5 2.5875 4.5 3V12C4.5 12.4125 4.64688 12.7656 4.94063 13.0594C5.23438 13.3531 5.5875 13.5 6 13.5H15C15.4125 13.5 15.7656 13.3531 16.0594 13.0594C16.3531 12.7656 16.5 12.4125 16.5 12V3C16.5 2.5875 16.3531 2.23437 16.0594 1.94062C15.7656 1.64687 15.4125 1.5 15 1.5H6ZM6 3H9.75V5.25H6V3ZM11.25 3H15V5.25H11.25V3ZM1.5 4.5V15C1.5 15.4125 1.64687 15.7656 1.94063 16.0594C2.23438 16.3531 2.5875 16.5 3 16.5H13.5V15H3V4.5H1.5ZM6 6.75H9.75V9H6V6.75ZM11.25 6.75H15V9H11.25V6.75ZM6 10.5H15V12H6V10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.a0b34f634464c8f40144a91c25aa6522.svg";
export { ForwardRef as ReactComponent };